module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addFavorites":"Add to favorites","removeFavorites":"Remove from favorites"},"es":{"addFavorites":"Agregar a favoritos","removeFavorites":"Quitar de favoritos"}}')
  delete Component.options._Ctor
}
